// Copyright (c) 2021 Deere & Company

import React, {PropTypes} from 'react';
import FileAttachmentSingle from '../../../claim/shared/components/file-attachment-single-panel/file-attachment-single';
import {FormattedMessage} from 'react-intl';
import LabeledCurrency from '../../../shared/components/labeled-currency';
import LabeledString from '../../../shared/components/labeled-string';
import LaborRate from '@deere/cps-it.warranty-model-factory/lib/labor-rate';
import {Link} from 'react-router';
import {buildDate} from '../../../shared/services/build-date';

const doNothing = () => ({});

const LaborRateRequestDetails = props =>

    <section className='labor-rate-request-details'>
        <div className='row'>
            {props.laborRateRequests.rates.map((laborRateRequestRate, index) =>
                <LabeledCurrency
                    className='lost-four-column'
                    data={laborRateRequestRate.requestedRate}
                    key={index}
                    label={laborRateRequestRate.description}
                />
            )}
            <LabeledString
                className='lost-four-column'
                data={buildDate(props.laborRateRequests.effectiveDate)}
                label='EFFECTIVE_DATE'
            />
            <LabeledCurrency
                className='lost-four-column'
                data={props.laborRateRequests.averageTechPayRate}
                label='AVERAGE_TECH_PAY_RATE'
                shouldTranslate={true}
            />
            <span className='attachment-label'>
                <FormattedMessage id='ATTACHMENTS'/>
            </span>
            <span className='attachment-field'>
                <FileAttachmentSingle
                    file={props.laborRateRequests.file}
                    onFileDelete={doNothing}
                    showDeleteIcon={false}
                />
            </span>
        </div>
        <LabeledString
            data={props.laborRateRequests.notesToDealer}
            label='COMMENTS_TO_DEALER'
        />
        <LabeledString
            data={props.laborRateRequests.rates[0].reasonForChange}
            label='DEALER_COMMENTS'
        />
        <div className='edit-button'>
            {
                props.laborRateRequests.requestStatus.key === 'RETURNED' ?
                    <Link to={`/claims/labor-rates/update-labor-rates/multiple?requestId=${props.laborRateRequests.requestId}`}>
                        <FormattedMessage id='EDIT'/>
                    </Link> : null
            }
        </div>
    </section>;

LaborRateRequestDetails.displayName = 'LaborRateRequestDetails';
LaborRateRequestDetails.propTypes = {
    actions: PropTypes.object.isRequired,
    isEditable: PropTypes.bool.isRequired,
    laborRateRequests: PropTypes.instanceOf(LaborRate).isRequired,
    onActionClick: PropTypes.func
};

export default LaborRateRequestDetails;



// WEBPACK FOOTER //
// ./src/claim/mass-labor-rate-request-status-details/components/labor-rate-request-details.js